import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import ScheduleIcon from '@material-ui/icons/Schedule';
import MenuIcon from '@material-ui/icons/Menu';

import { LinearProgress, CircularProgress, Typography, IconButton, Popover, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';


import Grow from '@material-ui/core/Grow';
import ArticleList from '../article-list';
import Article from '../article-list/article';
import PrintIcon from '@material-ui/icons/Print';
import NavigationIcon from '@material-ui/icons/Navigation';
import CheckIcon from '@material-ui/icons/Check';

import SmorderActions from '../../models/smorderActions';

class Order extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenuOpen: false,
    };
  }

  get contextMenuItems() {
    const { value, selectOrderForDeliveryTimeInfo, printOrder, isIncludedInRoute, removeOrderFromRoute, addOrderToRoute } = this.props;
    const items = [];

    if (this.canSetDelivery) {
      items.push(
        <MenuItem
          key="deliveryTime"
          onClick={() => {
            this.handlePopOverClose();
            selectOrderForDeliveryTimeInfo(value);
          }}
        >
          Lieferzeit setzen
        </MenuItem>,
      );
    }

    if (this.showPrintButton) {
      items.push(
        <MenuItem
          key="print"
          onClick={() => {
            this.handlePopOverClose();
            printOrder(value);
          }}
        >
          Drucken
        </MenuItem>,
      );
    }

    if (this.showRoutePlanningButton) {
      items.push(
        <MenuItem
          key="route"
          onClick={() => {
            this.handlePopOverClose();
            if (isIncludedInRoute) {
              removeOrderFromRoute(value);
              return;
            }
            addOrderToRoute(value);
          }}
        >
          {isIncludedInRoute ? 'aus Route entfernen' : 'zu Route hinzufügen'}
        </MenuItem>,
      );
    }

    return items;
  }

  get canSetDelivery() {
    const { value } = this.props;
    return value.actionsAllowed && value.actionsAllowed.includes(SmorderActions.SetExpectedDeliveryTime);
  }

  get showPrintButton() {
    const { value, localSettings } = this.props;

    return value.canPrint && !!localSettings && (localSettings.useEposPrinter || localSettings.printViaService);
  }

  get showRoutePlanningButton() {
    const { value, localSettings } = this.props;
    return value.canPrint && !!localSettings && localSettings.enableRouteplanning && value.isDelivery;
  }

  buttonStyle = {
    color: this.props.value.proceedColor,
    height: '48px',
  };

  handlePopOverClose() {
    this.setState({ contextMenuOpen: false });
  }

  renderPreOrderTime() {
    const { classes, value } = this.props;

    if (!value.pickupTime) {
      return null;
    }

    let label = value.pickupTimeIsSet ? 'Abholzeit' : 'Abholdatum';

    if (value.isDelivery) {
      label = 'Lieferzeit';
    }
    const dateTimeDevider = value.pickupTimeIsSet ? ' - ' : '';
    const pickupDate = moment().diff(moment(value.pickupDate, 'DD.MM.YYYY'), 'days') !== 0 ? dateTimeDevider + value.pickupDate : '';

    if (!pickupDate && !value.pickupTimeIsSet) {
      return null;
    }

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>
        <Typography className={classes.inlineTypography} style={{ color: moment(value.pickupTime, 'HH:mm').isBefore(moment()) ? '#cc0000' : 'black' }}>{value.pickupTimeIsSet ? value.pickupTime : ''}{pickupDate}</Typography>
      </div>
    );
  }

  renderOrderTime() {
    const { classes, value } = this.props;

    const label = 'Bestellzeit';

    const orderDate = moment().diff(moment(value.orderDate, 'DD.MM.YYYY'), 'days') !== 0 ? ` - ${value.orderDate}` : '';

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>
        <Typography className={classes.inlineTypography}>{value.orderTime}{orderDate}</Typography>
      </div>
    );
  }

  renderSpotName() {
    const { classes, value } = this.props;

    if (!value.spotName) {
      return null;
    }

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">{value.pickupTimeIsSet ? 'Standort' : 'Tisch'}</Typography>
        <Typography className={classes.inlineTypography}>{value.spotName}</Typography>
      </div>
    );
  }

  renderNickname() {
    const { classes, value } = this.props;

    if (!value.pickupCode) {
      return null;
    }

    const label = value.isDelivery ? 'Lieferung an' : 'Abholer';

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">{label}</Typography>
        <Typography className={classes.inlineTypography}>{value.pickupName}</Typography>
      </div>
    );
  }

  renderPickupCode() {
    const { classes, value } = this.props;

    if (!value.pickupCode) {
      return null;
    }

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">Bestellcode</Typography>
        <Typography className={classes.inlineTypography}>{value.pickupCode}</Typography>
      </div>
    );
  }

  renderTelephone() {
    const { value, classes } = this.props;

    const { telephone, isDelivery } = value;

    if (!telephone || isDelivery) {
      return null;
    }

    return (
      <div>
        <Typography className={classes.headerLabel} color="textSecondary">Tel.</Typography>
        <Typography className={classes.inlineTypography}>{telephone}</Typography>
      </div>
    );
  }

  renderCardActions = () => {
    const { classes, value, declineOrder, proceedOrder, hideActions, isRoutePlanning } = this.props;

    const { dispatchEvent } = value;

    if (hideActions || dispatchEvent || isRoutePlanning) {
      return null;
    }

    const declineButton = value.canReject
      ? (<Button
        variant="outlined"
        style={this.buttonStyle}
        className={classes.button}
        disabled={value.loading}
        onClick={() => declineOrder(value)}
      >
        Ablehnen
      </Button>)
      : null;

    const proceedButton = value.proceedText
      ? (<Button
        variant="outlined"
        style={this.buttonStyle}
        className={classes.button}
        disabled={value.loading}
        onClick={() => proceedOrder(value, value.proceedText)}
      >
        {value.proceedText}
      </Button>)
      : null;

    return (
      <CardActions className={classes.cardAction}>
        {declineButton}
        {proceedButton}
      </CardActions>
    );
  }

  renderTotalPrice() {
    const { classes, value, showTotalPrice } = this.props;

    return (
      <div className={classes.totalPriceWrapper}>
        <Typography className={classes.totalPrice}>Gesamt: {value.totalPrice.toFixed(2).replace('.', ',')}€</Typography>
      </div>
    );
  }

  renderDispatchEvent() {
    const { classes, value } = this.props;
    const { dispatchEvent } = value;

    if (!dispatchEvent) {
      return null;
    }

    const { timestamp, description, note, blockUser } = dispatchEvent;

    const noteComponent = note ?
      (<div><br />
        <Typography className={classes.inlineTypography} color="textSecondary">
          {note}
        </Typography>
      </div>)
      : null;

    const blockUserComponent = blockUser ?
      (<div>
        <br />
        <Typography className={classes.inlineTypography} color="textSecondary">
          Benutzer wurde blockiert
        </Typography>
      </div>)
      : null;

    return (
      <div>
        <Typography className={classes.headerLabelWide}>
          {description}
        </Typography>
        {noteComponent}
        {blockUserComponent}
        <br />
        <Typography className={classes.inlineTypography} color="textSecondary">
          {moment(timestamp).format('l, HH:MM')}
        </Typography>
      </div >
    );
  }

  renderDeliveryInformation() {
    const { classes, value, isRoutePlanning, localSettings } = this.props;

    const { address } = value;

    if (!value.isDelivery) { return null; }

    if (!isRoutePlanning && localSettings && localSettings.showDeliveryAdressInline) {
      return (
        <div>
          <Typography className={classes.deliveryInformation}>{address.companyName}</Typography>
          <Typography className={classes.deliveryInformation}>{address.street}</Typography>
          <Typography className={classes.deliveryInformation}>{address.zip} {address.city}</Typography>
          <Typography className={classes.inlineTypographyDotted}>Details anzeigen</Typography>
        </div>
      );
    }

    return (
      isRoutePlanning ?
        <div>
          <Typography className={classes.deliveryInformation}>{value.pickupName}</Typography>
          <Typography className={classes.deliveryInformation}>{address.companyName}</Typography>
          <Typography className={classes.deliveryInformation}>{address.street}</Typography>
          <Typography className={classes.deliveryInformation}>{address.zip} {address.city}</Typography>
          <Typography className={classes.deliveryInformation}>Stiege: {address.stairway || '-'} / Stock: {address.floor || '-'} / Tür: {address.door || '-'}</Typography>
        </div>
        :
        <div>
          <Typography className={classes.inlineTypographyDotted}>Adresse {'&'} Kontakt anzeigen</Typography>
        </div>

    );
  }

  renderContextMenuButton = () => {
    const { classes, value, printOrder, hideActions, printing, isRoutePlanning, addOrderToRoute, removeOrderFromRoute, isIncludedInRoute, localSettings } = this.props;

    const { contextMenuOpen, anchorEl } = this.state;

    if (hideActions || isRoutePlanning || (!this.canSetDelivery && !this.showPrintButton && !this.showRoutePlanningButton)) {
      return null;
    }

    if (!this.canSetDelivery) {
      return (
        <div className={classes.contextMenuContainer}>
          {this.showPrintButton ?
            <Button
              variant="outlined"
              style={this.buttonStyle}
              className={classes.button}
              disabled={value.loading}
              onClick={() => printOrder(value)}
            >
              {printing ?
                <CircularProgress size={20} />
                :
                <PrintIcon />
              }
            </Button >
            : null}
          {localSettings.enableRouteplanning && value.isDelivery ?
            (
              <Button
                variant="outlined"
                style={this.buttonStyle}
                disabled={value.loading}
                onClick={() => (
                  isIncludedInRoute
                    ? removeOrderFromRoute(value)
                    : addOrderToRoute(value)
                )}
              >
                {isIncludedInRoute ?
                  <CheckIcon />
                  :
                  <NavigationIcon />
                }
              </Button >
            ) : null
          }
        </div>
      );
    }

    return (
      <div className={classes.contextMenuContainer}>
        <Button
          variant="outlined"
          style={this.buttonStyle}
          className={classes.button}
          onClick={e => this.setState({ contextMenuOpen: true, anchorEl: e.currentTarget })}
        >
          <MenuIcon />
        </Button>
        <Popover
          open={contextMenuOpen}
          anchorEl={anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          anchorPosition={{ left: 1, top: 1 }}
          onClose={() => this.setState({ contextMenuOpen: false })}
        >
          {this.contextMenuItems}
        </Popover>
      </div>
    );
  }

  render() {
    const { classes, value, openDeliveryDialog, isRoutePlanning, addOrderToRoute, removeOrderFromRoute, isIncludedInRoute, localSettings } = this.props;
    const cardClass = value.loading ? classes.disabledCard : null;
    const loadingIndicator = value.loading
      ? <LinearProgress />
      : null;

    const note = value.userNote
      ? <Typography className={classes.userNote}>{value.userNote}</Typography>
      : null;

    const takeaway = value.takeaway || (value.note && value.note.includes('Abholung'))
      ? <Typography className={classes.takeaway}>Takeaway</Typography>
      : null;

    const notPaid = value.note && value.note.toUpperCase().includes('NICHT BEZAHLT')
      ? <Typography className={classes.takeaway}>NICHT BEZAHLT</Typography>
      : null;

    const cardStyle = {
      backgroundColor: isRoutePlanning ? (isIncludedInRoute ? 'yellowgreen' : 'rgba(0,0,0,0.5)') : value.color,
    };

    return (
      <Grow in={value.show}>
        <div className={classes.root} onClick={() => (isRoutePlanning ? isIncludedInRoute ? removeOrderFromRoute(value) : addOrderToRoute(value) : null)}>
          <Card className={cardClass} style={cardStyle}>
            <CardContent className={classes.cardContent}>
              <div>
                {loadingIndicator}
                {takeaway}
                {notPaid}
                {this.renderContextMenuButton()}
                <div className={classes.header} onClick={() => !isRoutePlanning && value.isDelivery && openDeliveryDialog(value)}>
                  {this.renderDispatchEvent()}
                  {this.renderNickname()}
                  {this.renderPickupCode()}
                  {this.renderPreOrderTime()}
                  {this.renderOrderTime()}
                  {this.renderSpotName()}
                  {this.renderDeliveryInformation()}
                  {this.renderTelephone()}
                </div>

                {note}

                <div className={classes.articleList}>
                  <ArticleList
                    value={value.articles}
                    tip={value.tip}
                    showPrices={localSettings.showArticlePrice}
                    showTip={localSettings.showTip}
                  />
                </div>
                {localSettings.showTotalPrice ? this.renderTotalPrice() : null}
              </div>
            </CardContent>
            {this.renderCardActions()}
          </Card>
        </div>
      </Grow>
    );
  }
}

const styles = theme => ({
  contextMenuContainer: {
    float: 'right',
    margin: '10px',
  },
  button: {
    fontSize: theme.order.buttons.fontSize,
    display: 'flex',
    'flex-grow': 1,
  },
  cardContent: {
    padding: 0,
  },
  header: {
    padding: 16,
  },
  headerLabel: {
    display: 'inline-block',
    width: 120,
  },
  headerLabelWide: {
    display: 'inline-block',
    width: 160,
  },
  inlineTypography: {
    display: 'inline-block',
  },
  inlineTypographyDotted: {
    display: 'inline-block',
    textDecoration: 'underline dotted',
    fontSize: 14,
    cursor: 'pointer',
  },
  articleList: {

  },
  totalPriceWrapper: {
    paddingLeft: '16px',
  },
  totalPrice: {
    fontWeight: 'bold',
  },
  userNote: {
    paddingLeft: '16px',
  },
  takeaway: {
    color: '#000',
    fontWeight: 'bold',
    padding: '16px 0 0 16px',
  },
  cardAction: {
    display: 'flex',
  },
  note: {
    padding: '0 16px',
    color: theme.palette.error.dark,
  },
  deliveryInformation: {
  },
});

Order.defaultProps = {
  hideActions: false,
  showTotalPrice: false,
  isRoutePlanning: false,
};

Order.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  proceedOrder: PropTypes.func.isRequired,
  declineOrder: PropTypes.func.isRequired,
  printOrder: PropTypes.func.isRequired,
  openDeliveryDialog: PropTypes.func.isRequired,
  selectOrderForDeliveryTimeInfo: PropTypes.func.isRequired,
  hideActions: PropTypes.bool,
  isRoutePlanning: PropTypes.bool,
  showTotalPrice: PropTypes.bool,
  localSettings: PropTypes.object.isRequired,
};

export default withStyles(styles)(Order);
